import { cn } from "@/lib/util";
import { useEffect, useState } from "react";

export interface AccessCodeViewProps
{
    onPassed?:()=>void;
}

export function AccessCodeView({
    onPassed,
}:AccessCodeViewProps){

    const [accessCode,setAccessCode]=useState('');
    const [error,setError]=useState('');
    useEffect(()=>{
        if(!error){
            return;
        }
        const iv=setTimeout(()=>{
            setError('');
        },3000);
        return ()=>{
            clearTimeout(iv);
        }
    },[error]);

    return (
        <div className="page--AccessCode stack-gap">
            <section className="section-gap stack-gap">
                <div className="glass p-8 rounded-major shadow-glass stack-gap">
                    <h1 className="hero-headline text-5xl sm:text-6xl jade tracking-tight">
                        Invite Only
                    </h1>
                    <p className="hero-subtle text-lg text-[rgba(247,244,239,0.8)] max-w-3xl">
                        Guardians Collective is currently under construction as is invite only.
                        Enter your access code below to continue.
                    </p>
                    <form className="flex items-stretch pt-2" onSubmit={(e)=>{
                        e.preventDefault();
                        setAccessCode('');
                        if(accessCode==='GC01'){
                            onPassed?.();
                        }else{
                            setError('Invalid Code');
                        }
                    }}>
                        <input type="text" value={accessCode} onChange={e=>setAccessCode(e.target.value)} className={cn("input max-w-60 text-[2rem]  rounded-r-none!",accessCode?'tracking-[1rem]':'')} placeholder="Access Code"/>
                        <button className="btn btn--primary text-[2rem] rounded-l-none!">Submit</button>
                        {!!error && <span className="tag-pill self-center ml-10 text-xl! px-4">{error}</span>}
                    </form>
                </div>
            </section>
        </div>
    )

}